<div class="position-absolute w-100" style="z-index: 2;">
  <div class="row">
    <div class="col-12">
      <app-register-okta class="d-flex"></app-register-okta>
    </div>
  </div>
</div>
